/*
* 项目详细信息组件
*/

import { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    Row,
    Col,
    message,
    Table,
    Input,
    Select,
    Button,
    Progress,
    Checkbox,
    Tag,
    Space,
    Statistic,
    theme,
} from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    DateFormat,
    winWidth,
    isGTscreenWidth,
    rootReactDom,
    GetDropdownActionName,
    GetArrSpanMaxWidth,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import Entity from './DetailEntity';
import DetailProgressLogEntity from './DetailProgressLogEntity.js';
import DetailToauditEntity from './DetailToauditEntity';
import DetailAuditedEntity from './DetailAuditedEntity';
import DetailRepaymentEntity from './DetailRepaymentEntity.js';
import DetailArchiveEntity from './DetailArchiveEntity.js';

const Option = Select.Option;
const MODULENAME = CNF.navItems[0].submenu[1].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[0].submenu[1].ptn;

//  项目进度渐变颜色
const progressColors = {
    '0%': '#108ee9',
    '100%': '#87d068',
};
//  项目回款渐变颜色
const repaymentColors = {
    '0%': '#ff0000',
    '100%': '#00ff00',
};

const Lists = (props) => {
    const {
        token: {
            colorPrimary,           // 主色
            colorPrimaryBg,         // 主色浅色背景色
            colorSuccess,
            colorSuccessBg,
            colorWarning,
            colorWarningBg,
            colorError,
            colorErrorBg,
            cyan1,
            cyan6,
        },
    } = theme.useToken();

    const update = (record) => { props.setOpen(true, record); }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = (action, record) => {
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.PROGRESS:
                progress(record);
                break;
            case CNF.actionName.TOAUDIT:
                toaudit(record);
                break;
            case CNF.actionName.AUDITED:
                audited(record);
                break;
            case CNF.actionName.REPAYMENT:
                repayment(record);
                break;
            case CNF.actionName.ARCHIVE:
                archive(record);
                break;
            default:
                break;
        }
    }

    const progress = (record) => {
        rootReactDom && rootReactDom.render(
            <DetailProgressLogEntity
                isRefresh={props.isRefresh}
                preGroup={props.preGroup}
                open={true}
                record={record}
                action={CNF.actionName.CREATE}
            />);
    }

    const toaudit = (record) => {
        rootReactDom && rootReactDom.render(
            <DetailToauditEntity
                isRefresh={props.isRefresh}
                preGroup={props.preGroup}
                open={true}
                record={record}
            />);
    }

    const audited = (record) => {
        rootReactDom && rootReactDom.render(
            <DetailAuditedEntity
                isRefresh={props.isRefresh}
                preGroup={props.preGroup}
                open={true}
                record={record}
            />);
    }

    const repayment = (record) => {
        rootReactDom && rootReactDom.render(
            <DetailRepaymentEntity
                isRefresh={props.isRefresh}
                preGroup={props.preGroup}
                btnLists={props.btnLists}
                open={true}
                record={record}
                action={CNF.actionName.CREATE}
            />);
    }

    const archive = (record) => {
        rootReactDom && rootReactDom.render(
            <DetailArchiveEntity
                isRefresh={props.isRefresh}
                preGroup={props.preGroup}
                open={true}
                record={record}
            />);
    }


    const columns = [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        { title: '项目名称', dataIndex: 'name', key: 'name', fixed: 'left', width: GetArrSpanMaxWidth(props.dataLists, 'name'), },
        { title: '项目编号', dataIndex: 'number', key: 'number', width: 180, },
        { title: '项目类型', dataIndex: 'type', key: 'type', width: 80, },
        { title: '项目阶段', dataIndex: 'phase', key: 'phase', width: 120, },
        { title: '项目区域', dataIndex: 'area', key: 'area', width: 120, },
        {
            title: '项目等级', key: 'rank', width: 120,
            render: function (record) {
                for (let item of CNF.projectRanks) {
                    if (parseInt(record.rank) === parseInt(item.value)) {
                        return item.key
                    }
                }
            }
        },
        {
            title: '项目进度', key: 'progress', width: 180,
            render: (record) => <Progress
                style={{ margin: 0 }}
                size='small' percent={record.progress} strokeColor={progressColors} />

        },
        {
            title: '合同编号', key: 'contract_number', width: 180,
            render: (record) => record.contract_number ? record.contract_number : '-'
        },
        {
            title: '合同签订日期', key: 'contract_date', width: 120,
            render: (record) => record.contract_date ? record.contract_date : '-'
        },
        {
            title: '合同金额(元)', key: 'contract_amount', width: 120,
            render: (record) => <Tag color={colorPrimaryBg} style={{ width: '100%' }}><Statistic precision={CNF.DPL} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorPrimary }} value={record.contract_amount} /></Tag>
        },
        {
            title: '送审金额(元)', key: 'audit_amount', width: 120,
            render: (record) => <Tag color={colorWarningBg} style={{ width: '100%' }}><Statistic precision={CNF.DPL} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorWarning }} value={record.audit_amount} /></Tag>
        },
        {
            title: '审定金额(元)', key: 'audited_amount', width: 120,
            render: (record) => <Tag color={colorErrorBg} style={{ width: '100%' }}><Statistic precision={CNF.DPL} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorError }} value={record.audited_amount} /></Tag>
        },
        {
            title: '回款金额(元)', key: 'repayment_amount', width: 120,
            render: (record) => <Tag color={colorSuccessBg} style={{ width: '100%' }}><Statistic precision={CNF.DPL} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorSuccess }} value={record.repayment_amount} /></Tag>
        },
        {
            title: '回款比例(%)', key: 'repayment_percent', width: 180,
            render: (record) => <Progress
                style={{ margin: 0 }}
                size='small'
                percent={record.repayment_amount ? (100 * record.repayment_amount / (record.audited_amount > 0 ? record.audited_amount : record.contract_amount)).toFixed(CNF.DPL) : 0.00}
                strokeColor={repaymentColors} />
        },
        {
            title: '待收金额(元)', key: 'unpaid_amount', width: 120,
            render: (record) => <Tag color={cyan1} style={{ width: '100%' }}><Statistic precision={CNF.DPL} valueStyle={{ fontSize: CNF.fontSize - 2, color: cyan6 }} value={record.unpaid_amount} /></Tag>
        },
        {
            title: '送审时间', key: 'audit_date', width: 120,
            render: (record) => record.audit_date ? record.audit_date : '-'
        },
        {
            title: '审定时间', key: 'audited_date', width: 120,
            render: (record) => record.audited_date ? record.audited_date : '-'
        },
        {
            title: '审计单位', key: 'audit_unit', width: GetArrSpanMaxWidth(props.dataLists, 'audit_unit'),
            render: (record) => record.audit_unit ? record.audit_unit : '-'
        },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        { title: '状态', dataIndex: 'status', key: 'status', fixed: 'right', width: CNF.tableStatusColumnWidth, },
        {
            title: '', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: (
                props.btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_progress') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_audit') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_audited') >= 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_repayment') >= 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_archive') >= 0
            ) ? false : true,
            render: (record) => GetDropdownActionName(props.btnLists, MODULENAME_PTN, record, operation)
        }
    ];
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={props.dataLists}
                scroll={{ x: winWidth }}
                pagination={{
                    showSizeChanger: false,
                    // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                    showQuickJumper: false,
                    showTotal: () => <>
                        合同金额: <Tag color={colorPrimaryBg}><Statistic precision={CNF.DPL} suffix={props.qss?.contract_amount > 10000 ? '万元' : '元'} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorPrimary }} value={props.qss?.contract_amount >= 10000 ? props.qss?.contract_amount / 10000 : props.qss?.contract_amount} /></Tag>
                        回款金额: <Tag color={colorSuccessBg}><Statistic precision={CNF.DPL} suffix={props.qss?.repayment_amount > 10000 ? '万元' : '元'} valueStyle={{ fontSize: CNF.fontSize - 2, color: colorSuccess }} value={props.qss?.repayment_amount >= 10000 ? props.qss?.repayment_amount / 10000 : props.qss?.repayment_amount} /></Tag>
                        待收金额: <Tag color={cyan1}><Statistic precision={CNF.DPL} suffix={props.qss?.unpaid_amount > 10000 ? '万元' : '元'} valueStyle={{ fontSize: CNF.fontSize - 2, color: cyan6 }} value={props.qss?.unpaid_amount >= 10000 ? props.qss?.unpaid_amount / 10000 : props.qss?.unpaid_amount} /></Tag>
                        共{props.pageCount > 10000 ? (props.pageCount / 10000).toFixed(CNF.DPL) + '万' : props.pageCount}条
                    </>,
                    pageSize: CNF.pageSize,
                    current: props.currentIndex,
                    total: props.pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => props.changeIndex(current),
                }}
            />
        </>
    );
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: null,
            open: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            name: '',
            number: '',
            type: '',
            phase: '',
            rank: 0,
            status: CNF.status[0].value,
            area: '',
            isUnfinish: 1,
        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeName = (e) => { this.setState({ name: e.target.value, }); this.search(); }
    changeNumber = (e) => { this.setState({ number: e.target.value, }); this.search(); }
    changeArea = (value) => { this.setState({ area: value }); this.search(); }
    changeType = (value) => { this.setState({ type: value === undefined ? '' : value, }); this.search(); }
    changePhase = (value) => { this.setState({ phase: value === undefined ? '' : value, }); this.search(); }
    changeRank = (value) => { this.setState({ rank: value === undefined ? 0 : value, }); this.search(); }
    changeStatus = (value) => { this.setState({ status: value, currentIndex: 1 }); this.isRefresh(); }
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    setOpen = (value, record) => { this.setState({ open: value, record: record }); }
    create = () => { this.setOpen(true, null); }

    /**
     * 获取列表
     */
    getLists() {
        const _this = this;
        const params = {
            'name': this.state.name,
            'number': this.state.number,
            'phase': this.state.phase,
            'type': this.state.type,
            'area': this.state.area,
            'rank': this.state.rank,
            'is_unfinish': this.state.isUnfinish,
            'status': this.state.status,
            'page_size': CNF.pageSize,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}project/details${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt,
                            qss: data.qss,
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0,
                            qss: {},
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    /***
    * 导出为 Excel
    */
    exportAsExecl = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '项目详细信息-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '项目详细信息明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '项目名称',
                    '项目编号',
                    '项目类型',
                    '项目阶段',
                    '项目区域',
                    '项目等级',
                    '项目进度(%)',
                    '合同编号',
                    '合同签订日期',
                    '合同金额(元)',
                    '送审金额(元)',
                    '审定金额(元)',
                    '回款金额(元)',
                    '待收金额(元)',
                    '送审时间',
                    '审定时间',
                    '审计单位',
                    '备注',
                    '状态'
                ],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出项目基础信息明细
     */
    export() {
        const _this = this;
        const params = {
            'name': this.state.name,
            'number': this.state.number,
            'phase': this.state.phase,
            'type': this.state.type,
            'area': this.state.area,
            'rank': this.state.rank,
            'is_unfinish': this.state.isUnfinish,
            'status': this.state.status,
            'page_size': 65535,
            'current_index': 1
        }
        $.ajax({
            url: `${CNF.api}project/details${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        // 删除非必须字段
                        var d = [];
                        for (let i = 0; i < data.dat.length; i++) {
                            var item = data.dat[i]
                            delete item['key'];
                            delete item['type_ulid'];
                            delete item['project_ulid'];
                            delete item['create_username'];
                            delete item['create_displayname'];
                            delete item['create_time'];
                            delete item['update_time'];
                            for (let i of CNF.projectRanks) {
                                if (parseInt(item['rank']) === parseInt(i.value)) {
                                    item['rank'] = i.key;
                                }
                            }
                            d.push(item);
                        }
                        _this.exportAsExecl(d);
                    } else {
                        _this.exportAsExecl([]);
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getLists();
    }

    render() {
        return (
            <>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 3 : 4}>
                        <Input
                            onChange={this.changeName}
                            placeholder='项目名称'
                            value={this.state.name}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 3 : 4} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Input
                            onChange={this.changeNumber}
                            placeholder='项目编码'
                            value={this.state.number}
                        />
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='项目类型'
                            style={{ width: '100%' }}
                            onChange={this.changeType}
                        >
                            {
                                CNF.projectTypes.map((item, index) => {
                                    return <Option key={index} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='项目阶段'
                            style={{ width: '100%' }}
                            onChange={this.changePhase}
                        >
                            {
                                CNF.projectPhases.map((item) => {
                                    return <Option key={item.value} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Input
                            onChange={this.changeArea}
                            placeholder='项目区域'
                            value={this.state.area}
                        />
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='项目等级'
                            style={{ width: '100%' }}
                            onChange={this.changeRank}
                        >
                            {
                                CNF.projectRanks.map((item) => {
                                    return <Option key={item.value} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='状态'
                            style={{ width: '100%' }}
                            onChange={this.changeStatus}
                        >
                            {
                                CNF.status && CNF.status.map((item) => {
                                    return <Option key={item.value} value={item.value}>{item.key}</Option>
                                })
                            }
                        </Select>
                    </Col>
                    <Checkbox style={{ height: 32, lineHeight: '32px', marginLeft: CNF.searchMarginLeft }}
                        disabled={this.state.loading}
                        checked={this.state.isUnfinish === 1 ? true : false}
                        onChange={(e) => {
                            e.target.checked ? this.setState({ isUnfinish: 1 }) : this.setState({ isUnfinish: 0 });
                            this.isRefresh();
                        }}>未结束</Checkbox>
                    <Space size={CNF.searchMarginLeft} style={{ marginLeft: CNF.searchMarginLeft }}>
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_export') >= 0 ? (
                                <Button
                                    title={CNF.actionName.EXPORT + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<ExportOutlined />}
                                    onClick={() => {
                                        this.export();
                                    }}>
                                    {CNF.actionName.EXPORT}
                                </Button>
                            ) : ''
                        }
                    </Space>
                    <Entity
                        preGroup={this.props.preGroup}
                        btnLists={this.props.btnLists}
                        open={this.state.open}
                        record={this.state.record}
                        setOpen={this.setOpen}
                        isRefresh={this.isRefresh}
                        areaDDList={this.state.areaDDList}
                    />
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            preGroup={this.props.preGroup}
                            btnLists={this.props.btnLists}
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            qss={this.state.qss}
                            changeIndex={this.changeIndex}
                            setOpen={this.setOpen}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </>
        );
    }
}

export default CPT